import {combineReducers} from 'redux-immutable';

import treeReducer from '../tree/reducer';
import ClientsMap from './component';


export const initialState = {};
export const reducer = combineReducers({
    regionsTree: treeReducer,
});
export const component = ClientsMap;
